import { createSlice } from '@reduxjs/toolkit';
import { dateRange } from '../../../utility/Utils';
// import { setEventsReducer } from '../../community/store/reducer';



export const calendar = createSlice({
  name: 'calendar',
  initialState: {
    classes: [],
    availableClasses:[],
    classCategoryRankInfo: [],
    classBookings: [],
    classBookedCounts: [],
    bookings: {
      bookingsData: [],
      linkAppointmentsData: [],
      directAppointmentsData: [],
      selectedBookingType: {},
      inviter: {},
      appointments: [],
      appointmentStats: {},
    },
    guestEvents: [],
    selectedBookingGroup:{},
    bookingTypesByFilter:[],
    selectedFilters: [],
    events:[],
    selectedFilters:["Classes","Events","Bookings"],
    bookedClassesAndBookings: { bookedClasses: [], bookedBookings: [], totalBookedClasses: 0, totalBookedBookings: 0 },
    bookedEvents: [],
  },
  reducers: {
    setClassesReducer: (state, action) => {
      const classes = [];
      action.payload.classes.map((classEvent) => {
        const classSessions = dateRange(
          classEvent.startDate,
          classEvent.endDate,
          classEvent.classDays
        );
        for (const cs of classSessions) {
          classes.push({
            ...classEvent,
            classColor: classEvent?.color ? classEvent.color : 'warning',
            start: new Date(cs + ' ' + classEvent.classStartTime.split(' ')[0]),
            end: new Date(cs + ' ' + classEvent.classEndTime.split(' ')[0]),
            title: classEvent.classTitle
          });
        }
      });

      state.classes = classes;
    },
    setClassCategoryRankInfoReducer: (state, action) => {
      state.classCategoryRankInfo = action.payload;
    },
    setClassBookings: (state, action) => {
      state.classBookings = action.payload;
    },
    setClassBookedCounts: (state, action) => {
      state.classBookedCounts = action.payload?.length ? action.payload : [];
    },
  
    selectedBookingTypeReducer: (state, action) => {
      state.bookings.selectedBookingType = action?.payload
    },
    selectedBookingGroupReducer:(state,action) =>{
      state.selectedBookingGroup = action?.payload
  },
    inviterReducer: (state, action) => {
      state.bookings.inviter = action?.payload
    },
    appointmentsReducer: (state, action) => {
      state.bookings.appointments = action?.payload
    },
    appointmentStatsReducer: (state, action) => {
      state.bookings.appointmentStats = action?.payload
    },
    setBookingsReducer: (state, action) => {
      state.bookings = action.payload;
    },
    setAvailableClassesReducer: (state, action) => {
      state.availableClasses = action.payload;
    },
    setGuestEventsReducer: (state, action) => {
      state.guestEvents = action.payload;
    },
    bookingTypesByFilterReducer:(state,action) =>{
      state.bookingTypesByFilter = action?.payload
    },
    eventsReducer:(state,action) =>{
      state.events = action?.payload
    },
    setBookedClassesAndBookings: (state, action) => {
      state.bookedClassesAndBookings = action.payload;
    },
    setBookedEvents: (state, action) => {
      state.bookedEvents = action.payload;
    }
  }
});

export const {
  setClassesReducer,
  setClassCategoryRankInfoReducer,
  setClassBookings,
  setClassBookedCounts,
  selectedBookingTypeReducer,
  inviterReducer,
  appointmentsReducer,
  appointmentStatsReducer,
  setBookingsRReducer,
  setGuestEventsReducer,
  selectedBookingGroupReducer,
  bookingTypesByFilterReducer,
  eventsReducer,
  setBookedClassesAndBookings,
  setBookedEvents,
  setAvailableClassesReducer,
  setBookingsReducer,
  setEventsReducer
} = calendar.actions;

export default calendar.reducer;
